module.exports = __webpack_public_path__ + "cced33086437636e4f0dda6a07e632c3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/quizzes.png
// module id = 1698
// module chunks = 0